export const pbCollections = {
    points: 'points',
    tripsMetaData: 'tripsMetaData',
    roles: 'roles',
    users: 'users',
    trips: "trips"
}

export const currentUserStorageKey = 'currentUser'